var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 3.5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#9FA7B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 3.5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#9FA7B3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 8.5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#9FA7B3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8.5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#9FA7B3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 13.5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#9FA7B3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 13.5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#9FA7B3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 18.5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#9FA7B3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 18.5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#9FA7B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.0e11c85e.svg";
export { ForwardRef as ReactComponent };